export enum MARKS_FAILS {
  BEFORE_MIN_RANGE = 1,
  BEFORE_MARK_TIME = 2,
  AFTER_TOLERANCE = 3,
  AFTER_MAX_RANGE = 4,
  AFTER_MAX_RANGE_OUT = 5,
  INVALID_TIME = 6,
}

export enum TIME_MARKS {
  ENTRADA = 1,
  SALIDA_REFRIGERIO = 2,
  RETORNO_REFRIGERIO = 3,
  SALIDA = 4,
}

export enum MARK_METHOD {
  WEB_DESKTOP = 1,
  APP = 2,
  EQUIPOS = 3,
  WEB_MOBILE = 4,
  FACE_ID = 5,
  FINGERPRINT = 6,
  PASSWORD = 7,
  CARD = 8
}
  